import React from 'react';
import toast from 'react-hot-toast';

import { useFieldArray, useFormContext } from 'react-hook-form';
import { CreatePollData } from '../types';

import Card from '@components/elements/Card';
import InputTextarea from '@components/elements/InputTextarea';
import { makeStyles } from '@mui/styles';

const useStyles = (randomColors) =>
  makeStyles({
    cbutton: {
      border: `solid 2px ${randomColors}`,
      '&:hover': {
        border: 'solid 2px transparent',
      },
    },
  });
interface PollCreateQuestionListProps {
  onItemClickEdit: (index: number) => void;
  neon?: string;
}

const PollCreateQuestionList: React.FC<PollCreateQuestionListProps> = ({
  onItemClickEdit,
  neon,
}) => {
  const form = useFormContext<CreatePollData>();

  const { fields, append, remove } = useFieldArray({
    name: 'questions',
  });

  const classes = useStyles(neon)();
  console.log(fields);

  const deletedQuestions = useFieldArray({
    name: 'deletedQuestions',
  });

  return (
    <div className="flex flex-col py-8 space-y-8">
      {fields?.map((field, index) => {
        const isMain = index === 0;
        const subPollId = form.getValues(
          `questions.${index}.subPollId` as const
        );
        const errors = form.formState.errors.questions?.[index];
        return (
          <div>
            {neon && (
              <h4
                style={{ color: neon }}
                className="mb-2 font-bold"
              >{`QUESTION ${index + 1} ${isMain ? '- Main' : ''}`}</h4>
            )}
            <Card
              neon={neon}
              key={field.id}
              title={
                neon
                  ? undefined
                  : `QUESTION ${index + 1} ${isMain ? '- Main' : ''}`
              }
              bgColor="white"
              shadowColor={isMain ? 'blue' : 'salmon'}
              accessory={
                <div
                  className="flex items-center justify-end h-full space-x-4"
                  style={{ color: 'white' }}
                >
                  {!isMain && (
                    <div>
                      <button
                        type="button"
                        className="font-bold text-opacity-50 select-none text-red font-display focus:outline-none"
                        onClick={() => {
                          if (subPollId) {
                            console.log('append', subPollId);
                            deletedQuestions.append({
                              subPollId: subPollId,
                            });
                          }
                          remove(index);
                        }}
                      >
                        REMOVE
                      </button>
                    </div>
                  )}
                  <div>
                    <button
                      type="button"
                      className="font-bold text-white select-none font-display focus:outline-none"
                      onClick={() => onItemClickEdit(index)}
                    >
                      EDIT OPTIONS
                    </button>
                  </div>
                </div>
              }
            >
              <InputTextarea
                neon={neon}
                className="p-4 text-xl font-bold border-none"
                placeholder={'Question title*'}
                rows={1}
                maxLength={80}
                {...form.register(`questions.${index}.question` as const)}
              />
              {errors && (
                <div className="flex justify-end px-2 pb-2 text-sm font-semibold text-red">
                  {errors.question
                    ? 'Must not be blank.'
                    : 'Options missing required fields.'}
                </div>
              )}
            </Card>
          </div>
        );
      })}
      <button
        type="button"
        style={{
          color: neon,
          position: 'absolute',
          bottom: -50,
          left: 0,
          width: '230px',
          height: 55,
        }}
        className={
          'w-full flex items-center justify-center  mt-4 px-3 py-4 text-lg font-bold  hover:bg-magenta hover:text-black  font-display  focus:outline-none ' +
          classes.cbutton
        }
        onClick={() => {
          if (fields.length >= 10)
            toast.error('A max of 10 poll questions is allowed');
          else {
            append({
              question: '',
              options: [
                { ...{ title: '', description: '' } },
                { ...{ title: '', description: '' } },
              ],

              maxVote: 1,
              isNotExact: false,
            });
          }
        }}
      >
        Add Question
      </button>
    </div>
  );
};

export default PollCreateQuestionList;
